// Role object for ShiftSupervisor with all true except ADMIN
export const ShiftSupervisor = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: false,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: true,
  },
};

// Role object for GATAdmin with all permissions set to true
export const GATAdmin = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: true,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: true,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: true,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: true,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: true,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: true,
  },
};

// Role object for ReadOnly with only view permissions
export const ReadOnly = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: false,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: false,
    EDIT_DRAFT_SHIFT: false,
    EDIT_PUBLISHED_SHIFT: false,
    PUBLISH_SHIFT: false,
    DELETE_DRAFT_SHIFT: false,
    CANCEL_PUBLISHED_SHIFT: false,
    COPY_SHIFT: false,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: false,
    RENOTIFY_WORKERS: false,
    MANUAL_ASSIGN_WORKERS: false,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: false,
    ACCEPT_INTEREST: false,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: false,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: false,
    OVERTIME_SHIFT_REQUEST: false,
    CREATE_COVERAGE_SHIFT: false,
    ACCEPT_REJECT_REGULAR_REQUEST: false,
    ACCEPT_REJECT_OVERTIME_REQUEST: false,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: false,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: false,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: false,
    EDIT_WORKERS: false,
    DELETE_WORKERS: false,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: false,
    EDIT_JOB_ROLES: false,
    VIEW_SKILLS: true,
    ADD_SKILLS: false,
    EDIT_SKILLS: false,
    MARK_SKILL_OBSOLETE: false,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: false,
    EDIT_CERTIFICATIONS: false,
    MARK_CERTIFICATION_OBSOLETE: false,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: false,
    CHANGE_STATUS: false,
    EDIT_DEMAND: false,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: false,
  },
};

// Role object for LimitedAccessSupervisor
export const LimitedAccessSupervisor = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: false,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: false,
    ACCEPT_INTEREST: false,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: false,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: false,
    EDIT_WORKERS: false,
    DELETE_WORKERS: false,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: false,
    EDIT_JOB_ROLES: false,
    VIEW_SKILLS: true,
    ADD_SKILLS: false,
    EDIT_SKILLS: false,
    MARK_SKILL_OBSOLETE: false,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: false,
    EDIT_CERTIFICATIONS: false,
    MARK_CERTIFICATION_OBSOLETE: false,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: false,
    CHANGE_STATUS: false,
    EDIT_DEMAND: false,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: false,
  },
};

export const HRManager = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: true,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: true,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: true,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: true,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: true,
    EXPORT_SCHEDULE: true,
  },
};

export const DepartmentManager = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: true,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: true,
  },
};

// ---------------------------------------------------------------------------
// Evaluation feature RBAC — backed entirely by the permissions array returned
// by /Users/authenticate. Roles are not consulted: a permission string is
// either present (granted) or absent (denied). These constants are the
// canonical source of permission keys so call sites avoid magic strings.
// ---------------------------------------------------------------------------

export const EVALUATION_PERMISSIONS = {
  VIEW: "evaluation.view",
  WORKERS: {
    VIEW: "evaluation.workers.view",
    VIEW_PROGRAMS: "evaluation.workers.view_programs",
    START_EVALUATION: "evaluation.workers.start_evaluation",
    VIEW_PROGRAM_INSTANCE: "evaluation.workers.view_program_instance",
    INSTANCE: {
      // Eligibility/due date override on a single program instance
      // (POST /WorkerEvaluationInstance/UpdateInstanceDates). Granted to
      // GATAdmin, CompanyAdmin, HrManager and TrainingManager only — the
      // endpoint rejects every other role, so the entry point stays hidden
      // rather than failing on save.
      EDIT_DATES: "evaluation.workers.instance.edit_dates",
    },
    FORM: {
      FILL: "evaluation.workers.form.fill",
      VIEW: "evaluation.workers.form.view",
    },
    ADDITIONAL_FIELDS: {
      EDIT: "evaluation.workers.additional_fields.edit",
    },
  },
  MY_ACKNOWLEDGEMENTS: {
    VIEW: "evaluation.my_acknowledgements.view",
    OPEN: "evaluation.my_acknowledgements.open",
    SIGN: "evaluation.my_acknowledgements.sign",
  },
} as const;

export const EVALUATION_SETUP_PERMISSIONS = {
  VIEW: "settings.evaluation_setup.view",
  TEMPLATE: {
    VIEW: "settings.evaluation_setup.template.view",
    ADD: "settings.evaluation_setup.template.add",
    EDIT: "settings.evaluation_setup.template.edit",
    DELETE: "settings.evaluation_setup.template.delete",
    MANAGE_LOCATIONS: "settings.evaluation_setup.template.manage_locations",
  },
  CATEGORY: {
    MANAGE: "settings.evaluation_setup.category.manage",
    ADD: "settings.evaluation_setup.category.add",
    EDIT: "settings.evaluation_setup.category.edit",
    DELETE: "settings.evaluation_setup.category.delete",
  },
  ACKNOWLEDGEMENT: {
    VIEW: "settings.evaluation_setup.acknowledgement.view",
    ADD: "settings.evaluation_setup.acknowledgement.add",
    EDIT: "settings.evaluation_setup.acknowledgement.edit",
    DELETE: "settings.evaluation_setup.acknowledgement.delete",
  },
  PLAN: {
    VIEW: "settings.evaluation_setup.plan.view",
    ADD: "settings.evaluation_setup.plan.add",
    EDIT: "settings.evaluation_setup.plan.edit",
    DELETE: "settings.evaluation_setup.plan.delete",
    CHANGE_STATUS: "settings.evaluation_setup.plan.change_status",
    ASSIGN: "settings.evaluation_setup.plan.assign",
  },
} as const;

// ---------------------------------------------------------------------------
// Settings module RBAC (GAT-7216) — same dynamic model as the evaluation
// constants above: the strings below are matched against the permissions array
// from /Users/authenticate via hasPermissionString(). Evaluation Setup already
// has its own block (EVALUATION_SETUP_PERMISSIONS) and is not repeated here.
//
// Seeded by GAT-7725. Note that /Users/authenticate also returns an older flat
// set for the same module — "settings.view_workers", "settings.add_workers",
// "settings.mark_skill_obsolete" and so on — left over from the GAT-6608
// Phase 1 catalog. Both namespaces are live, so a gate written against either
// one appears to work. Use these dotted codes: the flat set has no code for
// export, worker profile, skill level requirements, any user action beyond
// view, or leave balance, and it carries entries its own catalog tags
// "[Phase 0 generic — retire in Phase 2]".
//
// The Reports module keeps its own leave-balance report key; the keys below
// cover only the editable Leave Balance screen that hangs off Settings.
// ---------------------------------------------------------------------------

export const SETTINGS_PERMISSIONS = {
  VIEW: "settings.view",
  WORKERS: {
    VIEW: "settings.workers.view",
    ADD: "settings.workers.add",
    // Gates every edit affordance on the worker record: details, job roles,
    // skills and certifications tabs. A 1:1 replacement for the legacy
    // SETTINGS.EDIT_WORKERS key, which gated all four the same way.
    EDIT: "settings.workers.edit",
    DELETE: "settings.workers.delete",
    EXPORT: "settings.workers.export",
    // Opens the worker profile drawer (karma, reliability and consistency
    // scores). Flag-gated on showWorkerProfile today, with no permission.
    VIEW_PROFILE: "settings.workers.view_profile",
    // Lets the holder set a worker's skill level directly instead of going
    // through an evaluation form, when skill evaluation is enabled.
    EDIT_SKILLS_WITH_EVALUATION: "settings.workers.edit_skills_with_evaluation",
  },
  JOB_ROLES: {
    VIEW: "settings.job_roles.view",
    ADD: "settings.job_roles.add",
    EDIT: "settings.job_roles.edit",
  },
  SKILLS: {
    VIEW: "settings.skills.view",
    ADD: "settings.skills.add",
    EDIT: "settings.skills.edit",
    // Covers both directions of the toggle — mark obsolete and re-activate.
    MARK_OBSOLETE: "settings.skills.mark_obsolete",
    // Per-level requirement editor inside the skill dialog. Flag-gated on
    // isSkillLevelRequirementsEnabled today, with no permission.
    MANAGE_LEVEL_REQUIREMENTS: "settings.skills.manage_level_requirements",
  },
  CERTIFICATIONS: {
    VIEW: "settings.certifications.view",
    ADD: "settings.certifications.add",
    EDIT: "settings.certifications.edit",
    MARK_OBSOLETE: "settings.certifications.mark_obsolete",
  },
  WORKCENTERS: {
    // Work Centers is a read-only screen today, so view is the only key.
    VIEW: "settings.workcenters.view",
  },
  USERS: {
    // Replaces the roles.includes("HR Manager") check that used to decide
    // whether the Users entry appeared in the Settings submenu.
    VIEW: "settings.users.view",
    ADD: "settings.users.add",
    EDIT: "settings.users.edit",
    // Activate / deactivate a user. There is no hard delete on this screen.
    CHANGE_STATUS: "settings.users.change_status",
    // Act on a user who holds the HR Manager role. Restricted to GATAdmin
    // today by a hard-coded role check in use-supervisor-columns.tsx.
    MANAGE_HR_MANAGER: "settings.users.manage_hr_manager",
  },
  LEAVE_BALANCE: {
    VIEW: "settings.leave_balance.view",
    // Drives the editable balance grid; without it the screen is the
    // read-only report. Replaces REPORTS.UPDATE_LEAVE_BALANCE here only.
    EDIT: "settings.leave_balance.edit",
  },
} as const;
